<template>
  <div class="main-services grey-bg pt-120 pb-90" :style="{ backgroundImage: 'url(' + require('../../assets/img/pattern/pt1.png') + ')' }">
    <div class="container">
      <div class="row mb-60">
        <div class="col-12">
          <div class="sec-wrapper text-center">
            <h2 class="section-title">Rezultati i Pagesës</h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8 col-md-10 mb-30">
          <div class="mfbox mfbox-white text-center">
            <div class="mf-shape"></div>

            <!-- Loading / Polling -->
            <div v-if="status === 'loading'" class="payment-result-state">
              <div class="spinner mb-20"></div>
              <h3 class="mf-title">Duke verifikuar pagesën...</h3>
              <p>Ju lutemi prisni. Po konfirmojmë pagesën tuaj me uPay.</p>
            </div>

            <!-- Success -->
            <div v-else-if="status === 'paid'" class="payment-result-state">
              <div class="result-icon success mb-20">
                <i class="fas fa-check-circle"></i>
              </div>
              <h3 class="mf-title">Pagesa u krye me sukses!</h3>
              <p>Faleminderit, <strong>{{ name }}</strong>!</p>
              <p>Fatura <strong>{{ invoiceNo }}</strong> u pagua me sukses.</p>
              <p v-if="amount">Shuma: <strong>{{ amount }} EUR</strong></p>
              <p class="mt-20">Kartelën do ta merrni brenda 48 orësh.</p>
              <div class="mt-30">
                <router-link class="tp-btn" to="/">Kthehu në Faqen Kryesore</router-link>
              </div>
            </div>

            <!-- Pending (polling timed out) -->
            <div v-else-if="status === 'pending'" class="payment-result-state">
              <div class="result-icon pending mb-20">
                <i class="fas fa-clock"></i>
              </div>
              <h3 class="mf-title">Pagesa në pritje</h3>
              <p>Pagesa juaj po procesohet. Nëse keni kryer pagesën, do të merrni konfirmim me email brenda pak minutave.</p>
              <p>Nëse keni pyetje, ju lutemi na kontaktoni në <strong>046100011</strong>.</p>
              <div class="mt-30">
                <router-link class="tp-btn" to="/">Kthehu në Faqen Kryesore</router-link>
              </div>
            </div>

            <!-- Error -->
            <div v-else-if="status === 'error'" class="payment-result-state">
              <div class="result-icon error mb-20">
                <i class="fas fa-times-circle"></i>
              </div>
              <h3 class="mf-title">Gabim gjatë verifikimit</h3>
              <p>{{ errorMessage }}</p>
              <p>Ju lutemi na kontaktoni në <strong>046100011</strong> për ndihmë.</p>
              <div class="mt-30">
                <router-link class="tp-btn" to="/">Kthehu në Faqen Kryesore</router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../services/api';

export default {
  name: 'PaymentResult',
  data() {
    return {
      status: 'loading',   // 'loading' | 'paid' | 'pending' | 'error'
      invoiceNo: null,
      name: null,
      amount: null,
      errorMessage: null,
      pollCount: 0,
      maxPolls: 10,
      pollInterval: null,
    };
  },
  created() {
    this.invoiceNo =
      this.$route.query.invoiceNo ||
      sessionStorage.getItem('upay_invoiceNo') ||
      null;

    if (!this.invoiceNo) {
      this.status = 'error';
      this.errorMessage = 'Nuk u gjet asnjë faturë për verifikim. Ju lutemi na kontaktoni.';
      return;
    }

    this.checkStatus();
  },
  beforeUnmount() {
    this.clearPoll();
  },
  methods: {
    async checkStatus() {
      try {
        const response = await api.get(`api/upay/status?invoiceNo=${encodeURIComponent(this.invoiceNo)}`);
        const data = response.data;

        if (data.paid) {
          this.name = data.name;
          this.amount = data.amount;
          this.status = 'paid';
          sessionStorage.removeItem('upay_invoiceNo');
          this.clearPoll();
          return;
        }

        // Not yet paid — keep polling
        this.pollCount++;
        if (this.pollCount >= this.maxPolls) {
          this.status = 'pending';
          this.clearPoll();
          return;
        }

        this.pollInterval = setTimeout(() => this.checkStatus(), 3000);
      } catch (error) {
        console.error('uPay status check error:', error);
        if (error.response?.status === 404) {
          this.status = 'error';
          this.errorMessage = 'Fatura nuk u gjet në sistem. Ju lutemi na kontaktoni.';
        } else {
          // Network hiccup — retry unless exhausted
          this.pollCount++;
          if (this.pollCount >= this.maxPolls) {
            this.status = 'pending';
          } else {
            this.pollInterval = setTimeout(() => this.checkStatus(), 3000);
          }
        }
      }
    },
    clearPoll() {
      if (this.pollInterval) {
        clearTimeout(this.pollInterval);
        this.pollInterval = null;
      }
    },
  },
};
</script>

<style scoped>
.payment-result-state {
  padding: 30px 20px;
}
.spinner {
  width: 48px;
  height: 48px;
  border: 5px solid #e0e0e0;
  border-top-color: #0066cc;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin: 0 auto 20px;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
.result-icon {
  font-size: 3.5rem;
}
.result-icon.success { color: #28a745; }
.result-icon.pending { color: #ffc107; }
.result-icon.error   { color: #dc3545; }
.mt-20 { margin-top: 20px; }
.mt-30 { margin-top: 30px; }
.mb-20 { margin-bottom: 20px; }
</style>
